import React, { Children } from 'react';

interface iOlUlListProps extends React.HTMLAttributes<HTMLUListElement> {
  className?: string;
}

interface iListItemProps extends React.HTMLAttributes<HTMLLIElement> {
  className?: string;
}

interface iListProps {
  children: React.ReactNode[];
  type?: 'ol' | 'ul';
}

export const Ol = (props: iOlUlListProps) => {
  return <ol {...props}>{props.children}</ol>;
};

export const Ul = (props: iOlUlListProps) => {
  return <ul {...props}>{props.children}</ul>;
};

export const Li = (props: iListItemProps) => {
  const className = `
    list-li m-0 uppercase text-sm text-flint pt-0 pr-0 pb-[5px] pl-[7px] px-0 
    relative last:pb-0 before:content-[''] before:border-y-transparent 
    before:border-x-[#111] before:border-solid before:border-[3px_0_3px_4px] 
    before:block before:h-0 before:w-0 before:-left-[5px] before:top-[5px] before:relative
  `;
  
  return (
    <li
      className={className}
      {...props}
    >
      {props.children}
    </li>
  );
};

const renderItem = (child: React.ReactNode, i: number) => <Li key={i}>{child}</Li>;

export const List = (props: iListProps) => {
  const childrenArr = Children.toArray(props.children);
  const ListType = props.type === 'ol' ? Ol : Ul;

  return <ListType>{Children.map(childrenArr, renderItem)}</ListType>;
};
